import React, {useState} from "react";
import Dropdown from "react-dropdown";
import 'react-dropdown/style.css';
import DatePicker from "react-datepicker";
import Modal from 'react-bootstrap/Modal';
import Button from "react-bootstrap/Button";
import "react-datepicker/dist/react-datepicker.css";
import {API} from "../../api-service";
import format from "date-fns/format";
import { AdminStatus, Stat } from "../statuses";

export default function Appointment(props){

    const {handleMoveAll, ...rest} = props;

    const [startDate, setStartDate] = useState(props.cases[props.caseIndex].appointment_date? new Date(props.cases[props.caseIndex].appointment_date): new Date());
    const [message, setMessage] = useState("");
    const hours = ["00", "01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23"];
    const minutes = ["00", "15", "30", "45"];
    const [HH, setHH] = useState(props.cases[props.caseIndex].appointment_time? props.cases[props.caseIndex].appointment_time.substring(0, 2): null);
    const [MM, setMM] = useState(props.cases[props.caseIndex].appointment_time? props.cases[props.caseIndex].appointment_time.substring(3, 5): null);

    const confirmClicked = () => {
        if(HH && MM){
            let newCase = props.cases[props.caseIndex];
            if(props.cases[props.caseIndex].appointment_date){
                newCase.status = AdminStatus.aptresc.key;
                newCase.feedback_status = "Appointment Rescheduled";
            }
            else{
                newCase.status = AdminStatus.aptmade.key;
                newCase.feedback_status = "Appointment Made";
            }
            props.setCases(prev => {return [...prev.slice(0, props.caseIndex),
                                            newCase, 
                                            ...prev.slice(props.caseIndex+1)
            ]});
            newCase.appointment_date = format(startDate, "yyyy-MM-dd");
            if(HH.value){
                newCase.appointment_time = `${HH.value}:${MM.value}`;
            }
            else{
                newCase.appointment_time = `${HH}:${MM}`;
            }
            newCase.feedback_message = message
            API.updateCase(props.cases[props.caseIndex].reference_no, newCase, props.token['pn-token']);
            props.onHide();
            if(HH.value){
                alert(`Appointment set for ${format(startDate, "yyyy-MM-dd")} at ${HH.value}:${MM.value}`);
            }
            else{
                alert(`Appointment set for ${format(startDate, "yyyy-MM-dd")} at ${HH}:${MM}`);
            }
        }
        else{
            alert("Please set appointment time");
        }
    }

    return (
        <Modal
            show={props.show}
            onHide={props.onHide}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >

            <Modal.Header style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }}>
                <Modal.Title id="contained-modal-title-vcenter">
                    Case {props.cases[props.caseIndex].reference_no} 
                    
                </Modal.Title>
            </Modal.Header>

            <Modal.Body style={{
                display: "grid",
                gridTemplateColumns: "2fr 1fr",
                gridTemplateRows: "1fr",
                gridGap: "20px",
            }}>
                <div style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    }}>
                    <p>Select Date</p>
                    <DatePicker placeholder="Select Date" selected={startDate} onChange={(date) => setStartDate(date)} onKeyDown={e => e.preventDefault()}/>
                </div>
                <span></span>
                <div style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 0.45fr 0.1fr 0.45fr",
                    }}>
                    <p>Appointment Time</p>
                    <Dropdown placeholder={"HH"} options={hours} value={HH} onChange={(hh) => setHH(hh)}/>
                    <p style={{textAlign:'center', fontSize: 20}}>:</p>
                    <Dropdown placeholder="MM" options={minutes} value={MM} onChange={(mm) => setMM(mm)}/>
                </div>
                <span></span>
                <div style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    }}>
                    <p>Appointment Details</p>
                    <textarea onChange={(text) => setMessage(text.target.value)} value={message}/>
                </div>
                <span></span>
            </Modal.Body>

            <Modal.Footer>
                <Button onClick={confirmClicked}>Confirm</Button>
                <Button onClick={props.onHide}>Close</Button>
            </Modal.Footer>

        </Modal>
    );
}